import { createAction } from '@reduxjs/toolkit';

export const storesInitialized = createAction('storesInitialized');
